<template>
  <v-flex>
    <v-card-title class="card-title">
      Your Account
    </v-card-title>
    <v-divider />
    <v-card-title class="card-title">
      Avatar
      <file-uploader v-model="newAvatar" filetype="image/x-png, image/gif, image/jpeg">
        <template v-slot:activator>
          <span>UPLOAD AVATAR</span>
        </template>
      </file-uploader>
    </v-card-title>
    <v-flex class="avatar-container">
      <v-hover>
        <div
          slot-scope="{hover}"
          class="avatar-placeholder"
        >
          <v-avatar
            v-if="profile"
            :color="avatarColors[profile.name[0]]"
            size="64"
            class="avatar"
          >
            <img v-if="getAvatar" :src="getAvatar.link">
            <span v-else class="white--text">{{ profile.name | initials }}</span>
          </v-avatar>
          <v-fade-transition>
            <v-layout v-if="getAvatar && hover " class="avatar-hover">
              <v-flex>
                <v-icon
                  :color="colors.hwayzBrandGold"
                  class="hover-delete-icon"
                  title="delete"
                  @click="showConfirmModal=true"
                >
                  fas fa-trash-alt
                </v-icon>
              </v-flex>
            </v-layout>
          </v-fade-transition>
        </div>
      </v-hover>
    </v-flex>
    <confirm-modal
      :show="showConfirmModal"
      :text="text"
      @close-modal="closeModal"
      @click-button="confirmDelete"
    >
      <v-btn
        class="modal-confirm-button modal-confirm-button-cancel white--text"
        :color="colors.secondary"
        round
        @click="closeModal"
      >
        Cancel
      </v-btn>
    </confirm-modal>
  </v-flex>
</template>
<script>
import FileUploader from '../../components/uiUtils/FileUploader'
import ConfirmModal from '../../components/modals/ConfirmModal'
import { uploadNewAvatar, removeAvatar } from '../../services/profile'
import { mapMutations, mapGetters, mapState } from 'vuex'
import colors from '../../scss/_colors.scss'
import avatarColors from '../../utils/avatarColors'
export default {
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },
  components: {
    FileUploader,
    ConfirmModal
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      newAvatar: null,
      colors,
      avatarColors: avatarColors,
      showConfirmModal: false,
      text: 'Do you want to delete avatar?'

    }
  },
  computed: {
    ...mapGetters('agent', ['getClients']),
    ...mapState('common', [
      'profileStatus'
    ]),
    getAvatar() {
      const agentAvatar = this.profile && this.profile.media
        ? this.profile.media.find(item => item.type === 'avatar') : undefined
      return agentAvatar
    }
  },
  watch: {
    newAvatar() {
      this.updateAvatar()
    }
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    async updateAvatar() {
      if (this.newAvatar && this.newAvatar.newFile) {
        const imageFormData = new FormData()
        imageFormData.append('upload', this.newAvatar.newFile)
        const updatedProfile = await uploadNewAvatar(this.profile, imageFormData)
        this.updateProfile(updatedProfile)
      }
    },
    async deleteAvatar() {
      const updatedProfile = await removeAvatar(this.profile)
      this.updateProfile(updatedProfile)
    },
    updateProfile(profile) {
      if (this.profileStatus === 'agent') {
        profile.clients = this.getClients
        return this.setAgentData(profile)
      }
      return this.setClientData(profile)
    },
    closeModal() {
      this.showConfirmModal = false
    },
    confirmDelete() {
      this.showConfirmModal = false
      this.deleteAvatar()
    }
  }
}
</script>
<style lang="sass">
.avatar-container
  padding: 1rem 0 2rem
.avatar-placeholder
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  margin: 0 auto
  position: relative
  height: 64px
  width: 64px
.avatar-hover
  pointer-events: none
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  margin: 0 !important
  background-color: $hwayzMediumGray
  opacity: 0.9
  color: $hwayzWhite
  border-radius: 50% !important
  .hover-delete-icon
    pointer-events: all
    font-size: $hwayzFont1rem3 !important
    position: absolute
    bottom: 0.2rem
    right: -0.8rem
    cursor: pointer
.modal-confirm-button
  width: 40%
  border-radius: 20px
  color: $hwayzWhite
  font-weight: 300 !important
  &-cancel
    border: 1px solid $hwayzRed !important
    background-color: $hwayzRed !important
</style>
